(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["culture-halloween"] && !Shopify.designMode) return;
  try {
    const halloweenSection = document.getElementById('halloween');
if (Date.now() < 1790827200000 || Date.now() >= 1793505600000) {
  document.querySelectorAll('.ar-halloween-seasonal').forEach(element => element.remove());
} else if (halloweenSection) {
  const track = halloweenSection.querySelector('.ar-hw-track');
  const buttons = halloweenSection.querySelectorAll('[data-hw-direction]');
  const update = () => buttons.forEach(button => {
    button.disabled = Number(button.dataset.hwDirection) < 0 ? track.scrollLeft <= 1 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  });
  buttons.forEach(button => button.addEventListener('click', () => {
    track.scrollBy({left: Number(button.dataset.hwDirection) * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  }));
  track.addEventListener('scroll', update, {passive: true});
  window.addEventListener('resize', update);
  update();
}
  } catch(e) { console.error(e); }
})();

})();
